import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './HomePage.css';

const reportingLinks = {
  runbook: 'https://gemstoneitservices.sharepoint.com/sites/ISO27001/_layouts/15/Doc.aspx?sourcedoc=%7BBCAFEAA5-E51A-43A6-8F51-A24D8D7E2186%7D&file=Gemstone_ProjectReporting_Restoration_and_Runbook_2026-10-14_v1.0.docx&action=default&mobileredirect=true',
  production: 'https://app.powerbi.com/groups/6d165991-3408-4af6-ab3d-a5bfec915871/reports/93c805f8-f813-483c-a100-2c1ab1328b2c',
  test: 'https://app.powerbi.com/groups/9b628c3b-9a6c-4083-b027-ae19cdadc5ca/reports/9156c3a0-45ce-46b7-92e9-685a726ca45e',
};

const HomePage: React.FC = () => {
  const { hasPermission } = useAuth();
  const canUseReporting = ['finance.manage', 'projects.manage', 'jira-freeagent.manage'].some(hasPermission);
  const canUseDocuments = ['integrated-management-system.manage', 'integrated-management-system.audit'].some(hasPermission);
  return (
    <main className="container gcm-home py-5">
      <p className="gcm-home__eyebrow">Gemstone operations</p>
      <h1>Your internal services</h1>
      <p className="text-muted">Use the services menu to open the tools available to your role.</p>
      {(canUseReporting || canUseDocuments) && (
        <section className="gcm-home__reporting mt-4" aria-labelledby="reporting-heading">
          <div className="gcm-home__reporting-intro">
            <p className="gcm-home__eyebrow">Project Reporting</p>
            <h2 id="reporting-heading">Reports and how they work</h2>
            <p>Explore project delivery, time, contracts and financial reporting. The operations runbook explains the data sources, refresh schedules, deployment and recovery.</p>
          </div>
          <div className="gcm-home__links">
            {canUseReporting && <>
              <a href={reportingLinks.production} target="_blank" rel="noopener noreferrer">Open production report <span aria-hidden="true">↗</span></a>
              <a href={reportingLinks.test} target="_blank" rel="noopener noreferrer">Open TEST report <span aria-hidden="true">↗</span></a>
            </>}
            <a href={reportingLinks.runbook} target="_blank" rel="noopener noreferrer">Power BI reporting — how it works <span aria-hidden="true">↗</span></a>
            {canUseDocuments && <>
              <Link to="/integrated-management-system/policies/documents">Controlled documents <span aria-hidden="true">→</span></Link>
              <Link to="/integrated-management-system/registers/services">Service register <span aria-hidden="true">→</span></Link>
            </>}
          </div>
          <p className="gcm-home__access-note">Reports and documents open in a new tab and use their existing Microsoft access permissions. Refresh history is available in Power BI.</p>
        </section>
      )}
    </main>
  );
};

export default HomePage;
